// extracted by mini-css-extract-plugin
export default {"container":"Genre_container__iax26","left":"Genre_left__6Hj0j","right":"Genre_right__PUOey"};